import React from "react";
import "../App.css";
import {
  ComposableMap,
  Geographies,
  Geography,
} from "react-simple-maps";

// Country user data
const countryData = {
  "United Kingdom": 192,
  India: 64,
  China: 11,
  Nepal: 8,
};

// Normalize values for bar display
const maxUsers = Math.max(...Object.values(countryData));

const getColor = (country) => {
  const value = countryData[country];
  if (!value) return "#EEE";
  if (value >= 150) return "#9b5de5";
  if (value >= 50) return "#9b5de5bb";
  return "#9b5de555";
};

const UserByCountryMap = () => {
  return (
    <div className="user-map-wrapper">
      <div className="map-section">

        <ComposableMap projectionConfig={{ scale: 180 }}>
          <Geographies geography="/features.json">
            {({ geographies }) =>
              geographies.map((geo) => {
                const name = geo.properties.name;
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={getColor(name)}
                    stroke="#FFF"
                    style={{
                      default: { outline: "none" },
                      //hover: { fill: "#f0c", outline: "none" },
                      pressed: { outline: "none" },
                    }}
                  />
                );
              })
            }
          </Geographies>
        </ComposableMap>
      </div>

      <div className="country-list">
        <div className="country-table">
          <div className="table-header">
            <span className="header-country">Top Countries</span>
            <span className="header-users">Users</span>
          </div>

          {Object.entries(countryData).map(([country, value]) => (
            <div key={country} className="table-entry">
              <div className="table-row">
                <span className="country-name">{country}</span>
                <span className="user-value">{value}</span>
              </div>
              <div className="bar-wrapper">
                <div
                  className="bar-fill"
                  style={{ width: `${(value / maxUsers) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>


    </div>
  );
};

export default UserByCountryMap;
